import selectTimeIncrementOption from '../data/mutators/selectTimeIncrementOption';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import getTimeIncrement from '../selectors/getTimeIncrement';
/**
 * The TimeIncrement parameter specifies the scale that the Outlook on the web calendar uses to show time.
 * Valid values are: FifteenMinutes, ThirtyMinutes (default value)
 */
export default observer(function TimeIncrement() {
    var onTimeIncrementChange = function (ev, option) {
        selectTimeIncrementOption(parseInt(option.key));
    };
    var timeIncrementOptions = [
        {
            key: 15 /* FifteenMinutes */.toString(),
            text: strings.options_timeincrement_15_minutes,
        },
        {
            key: 30 /* ThirtyMinutes */.toString(),
            text: strings.options_timeincrement_30_minutes,
        },
    ];
    return (React.createElement(ChoiceGroup, { selectedKey: "" + getTimeIncrement(), label: strings.options_appearance_timeIncrementLabel, options: timeIncrementOptions, onChange: onTimeIncrementChange }));
});
//# sourceMappingURL=TimeIncrement.js.map